/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Dependent relationship type.
 *
 * Mirrors the monolith `DependentTypeEnum`, excluding employee-self
 * entries (those never appear on the `dependents` list).
 */
export enum DependentType {
  CHILD_OR_OTHER_DEPENDENT = 'CHILD_OR_OTHER_DEPENDENT',
  SPOUSE_OR_DOMESTIC_PARTNER = 'SPOUSE_OR_DOMESTIC_PARTNER',
}
